import { useState } from "react";

export default function MoveModal({ po, vendors, currentVendor, onConfirm, onCancel }) {
  const [target, setTarget] = useState(null);
  const others = vendors.filter((v) => v.name !== currentVendor);

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>Move document</h3>
        <p>Move <strong>{po.name}</strong> to a different vendor folder</p>
        {others.map((v) => (
          <div
            key={v.id}
            className={`vendor-option${target === v.name ? " chosen" : ""}`}
            onClick={() => setTarget(v.name)}
          >
            <i className="ti ti-folder" style={{ fontSize: 16, color: "#C9A227" }} aria-hidden="true" />
            {v.name}
          </div>
        ))}
        <div className="modal-actions">
          <button className="btn" onClick={onCancel}>Cancel</button>
          <button
            className="btn btn-primary"
            disabled={!target}
            onClick={() => target && onConfirm(po.id, target)}
          >
            Move here
          </button>
        </div>
      </div>
    </div>
  );
}
